import gql from 'graphql-tag';

export const GET_DSP_MINIMAL_LEGACY = gql`
  query DspMinimalLegacy($id: ID!) {
    dspLegacy(id: $id) {
      id
      name
      territories
    }
  }
`;

export const GET_DSP_LEGACY = gql`
  query DspLegacy($id: ID!, $territories: [Territory!]) {
    dspLegacy(id: $id) {
      id
      dailyCap
      maxAds
      name
      altId
      status
      seats(territories: $territories) {
        id
        altId
        name
        status
        externalSeatId
      }
      technicalProvider {
        id
        name
        status
        territories
      }
      territories
    }
  }
`;

export const GET_ALL_DSPS_LEGACY = gql`
  query AllDspsLegacy($technicalProviderId: ID, $territories: [Territory!]!) {
    allDspsLegacy(
      technicalProviderId: $technicalProviderId
      territories: $territories
    ) {
      id
      name
      dailyCap
      seats(filter: { status_in: [ACTIVE] }, territories: $territories) {
        id
        name
      }
      technicalProvider {
        id
        openSeatDsp {
          id
        }
      }
    }
  }
`;
